"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var AuthContentBody = (0, styled_components_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  background-color: ", ";\n  position: relative;\n"], ["\n  flex: 1;\n  background-color: ", ";\n  position: relative;\n"])), function (props) { return props.theme.colors.cremewhite; });
exports.default = AuthContentBody;
var templateObject_1;
//# sourceMappingURL=AuthContentBody.js.map